<template>
  <div>
    <form-wizard
      ref="wizard"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-3"
      :start-index.sync="activeIndex"
    >
      <!-- account detail tab -->
      <tab-content
        :title="$t('DEBTIA_NAVIGATION_HEADING_ONE')"
        icon="feather icon-menu"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              {{ $t('DEBTIA_INSTALLMENTPLAN_STEPONE_HEADING') }}
            </h5>
            <!--<small class="text-muted">
              {{ $t('message.DESC_PAYMENT_METHOD') }}
            </small>-->
          </b-col>
          <b-col
            lg="8"
            offset-lg="2"
            md="12"
          >
            <div>
              <!-- large -->
              <b-button-group
                size="lg"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :class="paymentmethod === 1 ? 'selectedmethod' : ''"
                  @click="methodselection(1)"
                >
                  {{ $t('DEBTIA_INSTALLMENTPLAN_PLANTYPES_ONE') }}
                </b-button>
                <b-button
                  v-if="isAmountBasedPlan"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :class="paymentmethod === 2 ? 'selectedmethod' : ''"
                  @click="methodselection(2)"
                >
                  {{ $t('DEBTIA_INSTALLMENTPLAN_PLANTYPES_TWO') }}
                </b-button>
                <b-button
                  v-if="isPeriodBasedPlan"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :class="paymentmethod === 3 ? 'selectedmethod' : ''"
                  @click="methodselection(3)"
                >
                  {{ $t('DEBTIA_INSTALLMENTPLAN_PLANTYPES_THREE') }}
                </b-button>
              </b-button-group>
            </div>
          </b-col>
        </b-row>
      </tab-content>

      <!-- amount/month tab -->
      <tab-content
        v-if="paymentmethod !== 1"
        :title="$t('DEBTIA_NAVIGATION_HEADING_TWO')"
        icon="feather icon-edit"
        :before-change="validationFormPlan"
      >
        <validation-observer
          ref="planningRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                {{ paymentmethod === 2 && paymentmethod !== 1 ? $t('DEBTIA_INSTALLMENTPLAN_STEPTWO_HEADING_AMOUNT') : $t('DEBTIA_INSTALLMENTPLAN_STEPTWO_HEADING_MONTH') }}
              </h5>
              <small class="text-muted">
                {{
                  paymentmethod === 2 && paymentmethod !== 1 ?
                    $t('DEBTIA_INSTALLMENTPLAN_STEPTWO_HEADING_AMOUNT_DESC') :
                    $t('DEBTIA_INSTALLMENTPLAN_STEPTWO_HEADING_MONTH_DESC')
                }}
              </small>
            </b-col>
            <b-col
              md="4"
              offset-lg="4"
            >
              <validation-provider
                #default="{ errors }"
                name="Planned Amount/Months(s)"
                rules="required"
                mode="passive"
              >
                <b-input-group :append="$t(placeholdertwo)">
                  <b-form-input
                    ref="installmentinput"
                    v-model="installmentValue"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="placeholderone"
                    type="number"
                    class="form-installment-input"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
                <div>
                  <small class="text-danger">
                    {{ showMessage === true ? errorMessage : '' }}
                  </small>
                </div>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- card details tab -->
      <tab-content
        :title="$t('DEBTIA_NAVIGATION_HEADING_THREE')"
        icon="feather icon-credit-card"
      >
        <div
          v-if="false"
          id="spinner-div"
        >
          <b-spinner
            key="success"
            variant="success"
            class="mr-1 custom-spinner-style"
            type="grow"
          />
        </div>
        <b-row v-if="isCardSaved && !hideInvokeBtn">
          <b-col
            cols="12"
            class="mb-2"
          >
            <small class="text-muted">*{{ $t('DEBTIA_SAVED_CARD_DETAILS_MSG') }}:</small>
          </b-col>
        </b-row>
        <div
          v-if="!hideInvokeBtn"
          class="text-align-center"
        >
          <b-button
            variant="relief-primary"
            @click="paymentInvoke"
          >
            <b-spinner
              v-if="fetchingFarPayLoader"
              label="Loading..."
            />
            <label
              v-else
              class="btn-style"
            >{{ $t('DEBTIA_CARD_DETAILS_BTN') }}</label>
          </b-button>
        </div>
        <b-row v-if="planPaymentMethod === 2">
          <b-col
            cols="12"
            class="mb-2"
          >
            <div
              id="dibs-complete-checkout"
            />
          </b-col>
        </b-row>
      </tab-content>

      <!-- declaration tab -->
      <tab-content
        v-if="paymentmethod !== 1"
        :title="$t('DEBTIA_NAVIGATION_HEADING_FOUR')"
        icon="feather icon-edit-2"
      />
      <b-row v-if="activeIndex === 3">
        <b-col
          cols="12"
          class="mb-2"
        >
          <h5 class="mb-0">
            {{ $t('DEBTIA_INSTALLMENTPLAN_STEPFOUR_HEADING') }}
          </h5>
          <small class="text-muted">{{ $t('DEBTIA_INSTALLMENTPLAN_STEPFOUR_HEADING_DESC') }}<br><p v-if="base64Signature">*{{ $t('DEBTIA_INSTALLMENTPLAN_SAVED_SIGNATURE_MESSAGE') }}</p></small>
        </b-col>
        <b-col
          lg="8"
          offset-lg="4"
        >
          <div
            class="tab-4"
          >
            <div class="pdf-div">
              <b-card class="text-center">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-1
                  variant="outline-primary"
                >
                  {{ $t('DEBTIA_INSTALLMENTPLAN_DECLARATIONPDF_BTN') }}
                </b-button>
              </b-card>
            </div>
            <div class="pdf-div">
              <Signature
                ref="signaturepad"
                :base64-signature="base64Signature"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal
        id="modal-1"
        hide-footer
        hide-header
      >
        <iframe
          :src="this.serverBaseUrl + pdfURL"
          width="100%"
          height="500px"
        />
      </b-modal>
      <template
        slot="footer"
        scope="props"
      >
        <div
          v-if="showbeforebutton"
          class="wizard-footer-left"
        >
          <wizard-button
            v-if="props.activeTabIndex > 0 && !props.isLastStep"
            :style="props.fillButtonStyle"
          >
            Previous
          </wizard-button>
        </div>
        <div
          v-if="((paymentmethod !== 1 && paymentmethod > 0) && ( activeIndex !== 2 || isCardSaved ) ) ||
            ((paymentmethod === 1 ) && ( activeIndex !== 1 || isCardSaved ))"
          class="wizard-footer-right"
        >
          <wizard-button
            v-if="!props.isLastStep"
            class="wizard-footer-right"
            :style="props.fillButtonStyle"
            @click.native="props.nextTab()"
          >{{ $t('DEBTIA_INSTALLMENTPLAN_NEXT') }}</wizard-button>
          <wizard-button
            v-else
            class="wizard-footer-right finish-button"
            :style="props.fillButtonStyle"
            @click.native="processcomplete()"
          >
            {{ props.isLastStep ? $t('DEBTIA_INSTALLMENTPLAN_DONE') : $t('DEBTIA_INSTALLMENTPLAN_NEXT') }}
          </wizard-button>
        </div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import {
  FormWizard,
  TabContent,
  WizardButton,
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BButtonGroup,
  BButton,
  BCard,
  BModal,
  VBModal,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, min } from '@validations'
import i18n from '@/libs/i18n'
import Signature from './steps/Signature.vue'

import axiosIns from '../../libs/axios'
import constants from '../../app-configs/constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    WizardButton,
    TabContent,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BButtonGroup,
    BButton,
    Signature,
    BCard,
    BModal,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: ['isPeriodBasedPlan', 'isAmountBasedPlan', 'minAmount', 'maxMonths', 'remainingAmount', 'planPaymentMethod', 'planResponse', 'startIndex', 'defaultCurrency', 'fullApiResponse'],
  data() {
    return {
      paymentmethod: 0,
      installmentValue: '',
      base64Signature: '',
      placeholderone: '',
      placeholdertwo: '',
      activeIndex: 0,
      type: '',
      required,
      min,
      installmentAmount: 0,
      totalInstallments: 1,
      errorMessage: '',
      showMessage: false,
      pdfURL: '',
      caseInformation: '',
      signedBack: 0,
      caseID: 0,
      installmentsData: [],
      payment_method: 0,
      cardtab: false,
      showbeforebutton: false,
      isCardSaved: false,
      isMethodChanged: false,
      hideInvokeBtn: false,
      serverBaseUrl: constants.serverBaseUrl,
      fetchingFarPayLoader: false,
    }
  },
  watch: {
    fullApiResponse: {
      handler() {
        if (this.fullApiResponse.data) this.assignValues()
      },
    },
  },
  // beforeCreate() {
  //   if (document.getElementById('paylike-script')) return // was already loaded
  //   const scriptTag = document.createElement('script')
  //   scriptTag.src = 'https://sdk.paylike.io/10.js'
  //   scriptTag.id = 'paylike-script'
  //   document.getElementsByTagName('head')[0].appendChild(scriptTag)
  //   if (document.getElementById('dibs-script')) return // was already loaded
  //   const dibsScriptTag = document.createElement('script')
  //   dibsScriptTag.src = 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1'
  //   dibsScriptTag.id = 'dibs-script'
  //   document.getElementsByTagName('head')[0].appendChild(dibsScriptTag)
  // },
  created() {
    // let token = window.location.href.split('/')
    // token = token.pop()
  },
  methods: {
    changeTab() {
      this.$refs.wizard.changeTab(2, 3)
    },
    assignValues() {
      const apiResponse = this.fullApiResponse
      this.base64Signature = apiResponse.data.signature ? apiResponse.data.signature : null
      this.paymentmethod = apiResponse.data.plan_type ? apiResponse.data.plan_type : 0
      if (apiResponse.data.is_payment === 1) {
        this.isCardSaved = true
      }
      this.installmentValue = apiResponse.data.plan_type && apiResponse.data.plan_type === 2 ? (apiResponse.data.installment_amount) / 100 : apiResponse.data.total_installments
      if (apiResponse.data.plan_type === 1) {
        this.installmentAmount = this.remainingAmount
      }
      if (apiResponse.data.period_based_plan === 0 && apiResponse.data.amount_based_plan === 0 && apiResponse.data.is_payment === 0) {
        this.paymentmethod = 1
        this.invokeFarPay()
        // this.installmentAmount = this.remainingAmount
        // this.methodselection(1)
        // this.$refs.wizard.changeTab(0, 1)
      }
      // console.log(`base64signature ${this.base64Signature} and paymentmethod ${this.paymentmethod} and installmentValue ${this.installmentValue}`)
      this.signedBack = apiResponse.data.plan_status
      this.caseID = apiResponse.data.journal_id
      this.payment_method = apiResponse.data.payment_method
      this.plannedPlaceholders(this.paymentmethod)
      if (this.signedBack === 1) {
        const pdfpath = `/storage/agreementplanpdf/pdfs/${this.caseID}_PDF.pdf`
        axiosIns.get(`installment_plan/getcasedetails/${this.caseID}`, {
          caseID: this.caseID,
        }).then(caseresponse => {
          console.log(caseresponse.data.data.default_currency)
          this.$refs.wizard.changeTab(0, 3)
          this.generatepdf(this.caseID)
        })
        this.pdfURL = pdfpath
      } else if (apiResponse.data.period_based_plan === 0 && apiResponse.data.amount_based_plan === 0 && apiResponse.data.journal_id.search('INV') !== -1) {
        this.preserveMethodAction(1)
      }
    },
    paymentInvoke() {
      if (this.planPaymentMethod === 4) {
        this.invokeFarPay()
      } else {
        this.dibsInvoke()
      }
    },
    popToken() {
      let token = window.location.href.split('/')
      token = token.pop()
      let urlToken = null
      if (token.includes('?')) {
        const fullResult = token.split('?')
        const result = fullResult.pop()
        this.farPayCallBackResponse = result.includes('success') ? 'success' : 'failure'
        // eslint-disable-next-line prefer-destructuring
        urlToken = fullResult[0]
        // this.saveTransaction(urlToken)
      } else {
        urlToken = token
      }
      return urlToken
    },
    async invokeFarPay() {
      // console.log('this.paymentmethod ', this.paymentmethod)
      this.fetchingFarPayLoader = true
      const urlToken = this.popToken()
      const url = `/farpay/order/create/${urlToken}`
      const data = {
        plan_type: this.paymentmethod,
      }
      await axiosIns.post(url, data).then(response => {
        if (response.status === 200) {
          // console.log(' response.data.data.response ', response.data.data.response)
          // console.log('far pay response is ', response.data.data.response)
          localStorage.setItem('farPayUrl', response.data.data.response.UserInputUrl)
          window.location.href = response.data.data.response.UserInputUrl
          this.fetchingFarPayLoader = false
        }
      })
    },
    makeDangerToast(variant = null) {
      this.$bvToast.toast(i18n.t('DEBTIA_SIGNATURE_ERROR_MSG'), {
        title: i18n.t('DEBTIA_CAUTION_TEXT'),
        variant,
        solid: false,
      })
    },
    validationFormPlan() {
      return new Promise((resolve, reject) => {
        this.$refs.planningRules.validate().then(success => {
          let installmentValueValidated = false
          if (this.paymentmethod === 2) {
            if (this.installmentValue >= this.minAmount && this.installmentValue <= this.remainingAmount) {
              installmentValueValidated = true
              this.installmentAmount = parseFloat(this.installmentValue).toFixed(2)
              this.totalInstallments = Math.ceil(parseFloat(this.remainingAmount) / parseFloat(this.installmentValue))
            } else {
              this.errorMessage = `Amount must be in between ${this.minAmount} and ${this.remainingAmount}`
            }
          } else if (this.paymentmethod === 3) {
            if (this.installmentValue <= this.maxMonths && this.installmentValue > 0) {
              installmentValueValidated = true
              this.installmentAmount = parseFloat(this.remainingAmount / this.installmentValue).toFixed(2)
              this.totalInstallments = this.installmentValue
            } else {
              this.errorMessage = `Month(s) must in between 1 and ${this.maxMonths}`
            }
          }
          if (success && installmentValueValidated) {
            this.showMessage = this.showMessage ? false : ''
            const token = this.popToken()
            // send installment plan method choice to server
            axiosIns.post('installment_plan/preserve_action', {
              token,
              action: 'save_installment_amount',
              installment_amount: this.installmentAmount * 100,
              total_installments: this.totalInstallments,
            }).then(() => {
              // if (response.status) {
              //   this.generatepdf()
              // }
            })
            if (!this.isCardSaved) {
              this.$emit('spintoggle', true)
              setTimeout(() => {
                // if (this.planPaymentMethod === 1) {
                //   // if (!this.isCardSaved) {
                //   // }
                // } else {
                //   document.getElementById('dibs-complete-checkout').innerHTML = ''
                //   this.dibsInvoke()
                // }
                this.invokeFarPay()
                this.$emit('spintoggle', false)
              }, 500)
            }
            resolve(true)
          } else {
            this.showMessage = true
            reject()
          }
        })
      })
    },
    methodselection(methodId) {
      if (methodId !== this.paymentmethod) {
        if (this.paymentmethod > 0) {
          this.confirmText(methodId)
        } else {
          this.preserveMethodAction(methodId)
        }
      }
    },
    confirmText(methodId) {
      // methodId
      const text = i18n.t('DEBTIA_PLAN_CHANGE_WARNING')
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION_TEXT'),
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isMethodChanged = result.value
          if (!this.installmentValue && this.paymentmethod !== 1) {
            this.$refs.planningRules.reset()
          }
          this.showMessage = false
          this.installmentValue = ''
          this.preserveMethodAction(methodId)
        }
      })
    },
    preserveMethodAction(methodId) {
      const token = this.popToken()
      axiosIns.post('installment_plan/preserve_action', {
        token,
        action: 'save_installment_plan',
        installment_plan: methodId,
      }).then(response => {
        console.log(response)
        this.paymentmethod = methodId
        if (methodId === 1) {
          this.$refs.wizard.changeTab(0, 2)
          this.installmentAmount = this.remainingAmount
          this.$emit('spintoggle', true)
          setTimeout(() => {
            if (this.planPaymentMethod === 4) {
              this.invokeFarPay()
            } else {
              document.getElementById('dibs-complete-checkout').innerHTML = ''
              this.dibsInvoke()
            }
            this.$emit('spintoggle', false)
          }, 500)
        } else {
          this.$refs.wizard.changeTab(0, 1)
          this.plannedPlaceholders(methodId)
        }
        return true
      })
    },
    plannedPlaceholders(methodId) {
      const amountplaceholder = i18n.t('DEBTIA_INSTALLMENTPLAN_STEPTWO_AMOUNT_PLACEHOLDER')
      const monthplaceholder = i18n.t('DEBTIA_INSTALLMENTPLAN_STEPTWO_MONTH_PLACEHOLDER')
      this.placeholderone = methodId === 2 && methodId !== 1 ? `${amountplaceholder} ${this.minAmount}` : `${monthplaceholder} ${this.maxMonths}`
      this.placeholdertwo = methodId === 2 && methodId !== 1 ? this.defaultCurrency : 'DEBTIA_MONTH_TEXT'
    },
    async processcomplete() {
      const result = await this.$refs.signaturepad.save(true)
      if (result) {
        const infoObejct = {
          status: true,
          paymentmethod: this.paymentmethod,
          pdfURL: this.pdfURL,
          caseInfo: this.caseInformation,
          installmentsData: this.installmentsData,
        }
        console.log('infoObejct', infoObejct)
        this.$emit('planCompleted', infoObejct)
      } else {
        this.makeDangerToast('danger')
      }
    },
    paylikeInvokeFullPayment() {
      this.cardtab = true
      const setup = {
        currency: 'DKK',
        locale: 'en',
      }
      const paylike = Paylike({ key: process.env.VUE_APP_PAYLIKE_PUBLIC_KEY })
      console.log(parseInt(this.installmentAmount * 100, 10))
      paylike.pay({
        test: process.env.VUE_APP_PAYLIKE_TEST === 'true',
        amount: { currency: setup.currency, exponent: 2, value: parseInt(this.installmentAmount * 100, 10) },
        title: 'Indfri din gæld fuldt ud',
        description: 'Det skyldige beløb vil blive hævet fra det indtastede kort',
        fields: [
          {
            name: 'name',
            placeholder: 'John Doe',
          },
        ],
      }, (err, res) => {
        if (err) {
          return console.log(err)
        }

        this.$emit('spintoggle', true)

        const data = {}
        data.amount = res.custom.amount * 100
        data.currency = setup.currency

        // send paylike transaction response to server
        axiosIns.post('payments/save_transaction', {
          action: 'save_paylike_response',
          token: window.location.href.split('/').pop(),
          transaction_id: res.transaction.id,
          transaction_response: JSON.stringify(res),
        }).then(response => {
          this.$emit('spintoggle', false)

          this.isCardSaved = true
          this.cardtab = false
          if (this.paymentmethod === 1) {
            const infoObejct = {
              status: true,
              paymentmethod: this.paymentmethod,
              caseInfo: {
                caseID: this.caseID,
                amountpaid: this.remainingAmount,
              },
            }
            this.$emit('planCompleted', infoObejct)
          } else {
            this.$refs.wizard.changeTab(2, 3)
          }
          console.log('paylike', response)
        })
        return true
      })
    },
    paylikeInvoke(currency) {
      console.log(currency)
      this.cardtab = true
      const setup = {
        currency,
        locale: 'en',
      }
      const paylike = Paylike({ key: process.env.VUE_APP_PAYLIKE_PUBLIC_KEY })
      paylike.pay({
        test: process.env.VUE_APP_PAYLIKE_TEST === 'true',
        amount: { currency, exponent: 2, value: 100 },
        title: 'Gem Kortoplysninger',
        description: 'Der vil reserveres 1,00 kr. for at godkende gyldighed af kortet. Dette beløb vil blive refunderet efterfølgende',
        fields: [
          {
            name: 'name',
            placeholder: 'John Doe',
          },
        ],
      }, (err, res) => {
        if (err) {
          return console.log(err)
        }
        this.$emit('spintoggle', true)

        const data = {}
        // data.amount = res.custom.amount * 100
        data.currency = setup.currency

        // send paylike transaction response to server
        axiosIns.post('payments/save_transaction', {
          action: 'save_paylike_response',
          token: window.location.href.split('/').pop(),
          transaction_id: res.transaction.id,
          transaction_response: JSON.stringify(res),
        }).then(response => {
          this.$emit('spintoggle', false)
          this.isCardSaved = true
          this.cardtab = false
          if (this.paymentmethod === 1) {
            const infoObejct = {
              status: true,
              paymentmethod: this.paymentmethod,
              caseInfo: {
                caseID: this.caseID,
                amountpaid: this.remainingAmount,
              },
            }
            this.$emit('planCompleted', infoObejct)
          } else {
            this.$refs.wizard.changeTab(2, 3)
          }
          console.log('paylike', response)
        })
        return true
      })
    },
    dibsInvoke() {
      document.getElementById('dibs-complete-checkout').innerHTML = ''
      this.hideInvokeBtn = true
      this.cardtab = true
      let paymentID
      let obj
      axiosIns.post('dibs/create-payment', {
        action: 'dibs_create_payment_id',
        token: window.location.href.split('/').pop(),
        installment_amount: 0,
      }).then(data => {
        paymentID = JSON.stringify(data)
        obj = JSON.parse(paymentID)
        console.log(obj)
        paymentID = obj.data.paymentId
        console.log(paymentID)
        const checkoutOptions = {
          paymentId: paymentID,
          checkoutKey: '25616be8f790488e8f2bed1f5ae80257',
          language: 'en-GB',
          containerId: 'dibs-complete-checkout',
        }
        console.log(checkoutOptions)
        /* eslint-disable */
        const checkout = new Dibs.Checkout(checkoutOptions)
        /* eslint-enable */
        console.log(checkout)

        checkout.on('payment-completed', res => {
          console.log(res)
          // send paylike transaction response to server
          axiosIns.post('payments/save_transaction', {
            action: 'save_dibs_response',
            token: window.location.href.split('/').pop(),
            transaction_id: paymentID,
            transaction_response: JSON.stringify(res),
          }).then(response => {
            this.isCardSaved = true
            // console.log('ssss coming')
            this.cardtab = false
            if (this.paymentmethod === 1) {
              const infoObejct = {
                status: true,
                paymentmethod: this.paymentmethod,
                caseInfo: {
                  caseID: this.caseID,
                  amountpaid: this.remainingAmount,
                },
              }
              this.$emit('planCompleted', infoObejct)
            } else {
              this.$refs.wizard.changeTab(2, 3)
            }
            console.log(response)
          })
        })
      }).catch(e => {
        console.error(e)
      })
    },
    generatepdf(journalId) {
      const urlToken = this.popToken()
      axiosIns.post('installment_plan/generate_installmentplan_pdf', {
        action: 'generate_plan_pdf',
        token: urlToken,
        journal_id: journalId,
      }).then(response => {
        console.log(response)
        this.pdfURL = response.data.agreement_pdf_url
        this.caseInformation = response.data.caseInformation
        this.installmentsData = response.data.installments_data
      })
    },
  },
}
</script>
<style scoped>
.pdf-div{
  height: auto;
  max-width: 400px;
  border-radius: 5px;
}
.pdf-p {
    margin-top: 23%;
    margin-left: 40%;
  }
.sign-div{
  margin-top: 25px;
}
.pdf-div:nth-child(2) {
  margin-top: 10px;
}

.selectedmethod{
    background-color: #64908c !important;
    color: white !important;
}
#step-PaymentMethodSelection0{
    border-color: rgb(228 228 228) !important;
    background-color: rgb(236 236 236) !important;
}

.cardtabstyle{
  display: none;
}

.text-align-center{
  text-align: center;
}

.custom-spinner-style{
  margin-left: 50%;
  margin-top: 10%;
}

.btn-style {
  color: white;
}
</style>
